import service from "./service";

const encodeInquiryId = (inquiryId) => {
  if (typeof inquiryId !== "string" && typeof inquiryId !== "number") {
    throw new Error("A valid inquiry ID is required for chat requests.");
  }
  const id = String(inquiryId).trim();
  if (!id) throw new Error("A valid inquiry ID is required for chat requests.");
  return encodeURIComponent(id);
};

const getChats = ({ page = 1, limit = 20 } = {}) =>
  service.get("vendors/chats?page=" + page + "&limit=" + limit);

const getUnreadCount = () => service.get("vendors/chats/unread-count");

const markMessagesRead = (inquiryId) =>
  service.put(
    "vendors/chats/" + encodeInquiryId(inquiryId) + "/messages/read",
    {},
  );

const getChat = (inquiryId) =>
  service.get("vendors/chats/" + encodeInquiryId(inquiryId));

const getMessages = (inquiryId, { page = 1, limit = 20 } = {}) =>
  service.get(
    "vendors/chats/" +
      encodeInquiryId(inquiryId) +
      "/messages?page=" +
      page +
      "&limit=" +
      limit,
  );

const sendMessage = (inquiryId, payload, attachment = null) => {
  const url = "vendors/chats/" + encodeInquiryId(inquiryId) + "/messages";
  if (typeof FormData !== "undefined" && payload instanceof FormData) {
    return service.postForm(url, payload);
  }

  const formData = new FormData();
  formData.append("message", String(payload?.message || ""));
  if (attachment) formData.append("attachments", attachment);
  return service.postForm(url, formData);
};

const chatService = {
  getChats,
  getUnreadCount,
  markMessagesRead,
  getChat,
  getMessages,
  sendMessage,
};
export default chatService;
